import React from 'react';
import { Box, PageContent, Stack } from 'bumbag';

import LayoutPage from 'legacy/components/checkout/layout/Page';
import RedirectCountdown from 'legacy/components/checkout/RedirectCountdown';
import CompletedTransactionMessage from 'legacy/components/CompletedTransactionMessage';
import { getKeyFromQueryParams } from 'legacy/utils/router';

import { TRANSACTION_ACTIONS } from '../../constants';

type Props = {};
type State = {
  returnUrl?: string;
};

export default class RequestExpired extends React.PureComponent<Props, State> {
  state = {
    returnUrl: getKeyFromQueryParams('returnUrl'),
  };

  render = () => {
    const { returnUrl } = this.state;
    return (
      <LayoutPage title="Payment request expired">
        <PageContent breakpoint="checkout">
          <Stack spacing="major-2">
            <CompletedTransactionMessage type={TRANSACTION_ACTIONS.EXPIRED} />
            {returnUrl && (
              <Box textAlign="center">
                <RedirectCountdown redirectUrl={returnUrl} />
              </Box>
            )}
          </Stack>
        </PageContent>
      </LayoutPage>
    );
  };
}
